import { mapState } from 'vuex';
import { themesMixin } from '../../utils/themes';
import ApiService from '../../services/apiService';
export default {
  name: 'CoreExportDialog',
  mixins: [themesMixin],
  props: {
    jobType: {
      type: String,
      required: false,
      default: () => 'export'
    },
    useBackgroundRunnerExport: {
      type: Boolean,
      required: false,
      default: () => false
    },
    tenantId: {
      type: Number,
      required: true
    },
    exportButtonIcon: {
      type: String,
      required: false,
      default: 'fa-file-csv'
    },
    format: {
      type: String,
      required: true
    },
    resource: {
      type: String,
      required: false,
      default: ''
    },
    query: {
      type: Object,
      required: false,
      default: () => ({})
    },
    formValid: {
      type: Boolean,
      required: false,
      default: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      valid: this.formValid,
      name: '',
      email: '',
      emailRules: [v => !v || /.+@.+\..+/.test(v) || this.$i18n_t('Common.emailValid')]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    backgroundColor() {
      return `background-color: ${this.vuetifyColorHex('info')}`;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    }
  },
  methods: {
    submit() {
      const search = this.$route.params.id;
      const data = this.useBackgroundRunnerExport ? {
        tenantId: this.tenantId,
        title: this.name,
        type: this.resource === 'virtual-device-state-values' ? 'virtualDevice' : 'digitalTwin',
        deviceId: parseInt(search, 10),
        stateIdentifiers: (this.query.variables || []).map(q => q.key),
        fromTime: new Date(this.query.time.from).toISOString(),
        toTime: new Date(this.query.time.to).toISOString()
      } : {
        name: this.name,
        type: this.jobType,
        format: this.format,
        resource: this.resource,
        query: this.query,
        notification: this.email ? {
          email: [this.email]
        } : null
      };
      const apiMethod = this.useBackgroundRunnerExport ? ApiService.createBackgroundRunnerSingleExportDeviceStates : ApiService.createBackgroundJob;
      return apiMethod(data).then(result => {
        this.$emit('close');
        this.$snack(this.$i18n_t('Core.ExportDialog.snacks.createSuccess'), 'success');
        return result;
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack('Failed to create background job', 'error');
        }
      });
    }
  }
};